import React, { useState } from 'react';
import './LoginForm.css';
import LoginImage from '../../assests/logo_login.png';

const LoginPage = ({ onLogin }) => {
    const [loginInput, setLoginInput] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!loginInput || !password) {
            setErrorMessage('Por favor, preencha todos os campos.');
            return;
        }
        setErrorMessage('');
        setIsLoading(true);
        try {
            console.log("Tentativa de login com:", loginInput, password);
            await onLogin(loginInput, password);
        } catch (error) {
            setErrorMessage('Credenciais inválidas. Tente novamente.');
            console.error("Erro de login:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-container">
                <div className="login-image">
                    <span className="logo-text">CertiLaw</span>
                </div>
                <form className="login-form" onSubmit={handleSubmit}>
                    {errorMessage && <p className="error">{errorMessage}</p>}
                    <div className="form-group">
                        <input
                            type="text"
                            value={loginInput}
                            onChange={(e) => setLoginInput(e.target.value)}
                            placeholder="Digite seu email ou nome de usuário"
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Digite sua senha"
                        />
                    </div>
                    <button type="submit" className="login-btn" disabled={isLoading}>
                            {isLoading ? <><span className="spinner" /> Carregando...</> : 'Entrar'}
                        </button>
                </form>
            </div>
            {/* RODAPÉ */}
            <div className="footer">
                © {new Date().getFullYear()} CertiLaw. Todos os direitos reservados.
            </div>
        </div>
    );
};

export default LoginPage;